import { render, staticRenderFns } from "./EventFreeTagComponent.vue?vue&type=template&id=b04de62c&scoped=true&"
import script from "./EventFreeTagComponent.vue?vue&type=script&lang=js&"
export * from "./EventFreeTagComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04de62c",
  null
  
)

export default component.exports